import { ComponentBaseProps } from "[root]/src/lib";

type CardTitleProps = Pick<ComponentBaseProps, "children">;

export const CardTitle = ({ children }: CardTitleProps) => (
  <h2 className="card-title">{children}</h2>
);
